import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/biz/mrstore/${url}`, ...arg)

const storePage = (data) => request('page', data, 'get')
const storeList = (data) => request('list', data, 'get')
const createStore = (data) => request('add', data)
const updateStore = (data) => request('edit', data)
const saveStore = (data) => (data?.id ? updateStore(data) : createStore(data))
const deleteStore = (data) => request('delete', data)
const getStoreDetail = (data) => request('detail', data, 'get')
const getRegionChildren = (data) => request('region/children', data, 'get')

export default {
	storePage,
	storeList,
	createStore,
	updateStore,
	saveStore,
	deleteStore,
	getStoreDetail,
	getRegionChildren
}
